import React from 'react';
import Header from '../../componentes/comuns/Header';
import Footer from '../../componentes/comuns/Footer';
import Ofertaschips from '../../componentes/comuns/Ofertaschips';
import styles from './Pagina3.module.css';
import HelpSection from '../../componentes/comuns/HelpSection';
import FaixaPlanos from '../../componentes/comuns/FaixaPlanos';
import InfinitePossibilities from '../../componentes/comuns/InfinitePossibilities';


const Pagina3 = () => {
    return (
        <>
            <Header />

            <main className={styles.mainContent}>

                <div>
                    <Ofertaschips />
                </div>
                <div className={styles.faixa}>
                    <FaixaPlanos />
                </div>
                <div>
                    <InfinitePossibilities/>
                </div>

                <div>
                    <HelpSection />
                </div>


            </main>
            <Footer />
        </>
    );
}

export default Pagina3;